import React from 'react';
import { Modal, Box, Button, Flex, ModalBody, ModalCloseButton, ModalHeader, Text } from '@televet/kibble-ui';
import { YellowBone } from 'assets/icons';
import { useGetRewards } from '../hooks/useGetRewards';

interface RewardsListModalProps {
  isOpen: boolean;
  onClose: () => void;
  programId: string;
}

export const RewardsListModal = ({ isOpen, onClose, programId }: RewardsListModalProps): JSX.Element => {
  const { rewards, rewardsCount, fetchMore, loading } = useGetRewards(programId);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="sm" scrollBehavior="inside">
      <ModalCloseButton />
      <ModalHeader>Reward List</ModalHeader>
      <ModalBody pt={4} mb={4} maxH="450px">
        {rewards.map((reward) => (
          <Flex
            key={reward.id}
            alignItems="center"
            border="1px"
            borderRadius="base"
            borderColor="border.default"
            boxShadow="md"
            mb={4}
          >
            <Box
              py={3}
              bgColor="background.contrast"
              borderTopLeftRadius="base"
              borderBottomLeftRadius="base"
              minW="90px"
            >
              <Flex alignItems="center" justifyContent="center">
                <Text variant="onContrast" size="2xl" fontWeight="bold" mr={1}>
                  {reward.pointCost}
                </Text>
                <YellowBone />
              </Flex>
            </Box>
            <Flex px={2} alignItems="center">
              <Text isTruncated fontWeight="bold" noOfLines={2}>
                {reward.title}
              </Text>
            </Flex>
          </Flex>
        ))}
        {rewards.length !== rewardsCount && (
          <Button
            variant="ghost"
            isFullWidth
            size="sm"
            isLoading={loading}
            isDisabled={loading}
            onClick={(): Promise<void> => fetchMore()}
          >
            Show More
          </Button>
        )}
        {!rewards.length && <Text variant="subtle">There are no active rewards.</Text>}
      </ModalBody>
    </Modal>
  );
};
